import { Component } from '@angular/core';
import { cloneDeep } from 'lodash';
import { ModalConfirmationService } from 'src/app/services/modal-confirmation.service';
import { SelfTrainingToolService } from 'src/app/services/self-training-tool.service';
import { TabsService } from 'src/app/services/tabsService';

@Component({
  selector: 'app-self-training-tool',
  templateUrl: './self-training-tool.component.html',
  styleUrls: ['./self-training-tool.component.scss'],
  standalone: false
})
export class SelfTrainingToolComponent {

  sliders: { value: number }[] = [{ value: 50 }]; // Initial sliders

  constructor(
    public tabsService: TabsService,
    public selfTrainingToolService: SelfTrainingToolService,
    private modelConfirmationMessage: ModalConfirmationService
  ) { }

  async saveState(){
    this.selfTrainingToolService.loading = true;

    await this.selfTrainingToolService.saveExercises(this.selfTrainingToolService.exerciseList);

    this.selfTrainingToolService.exerciseListBackUp = cloneDeep(this.selfTrainingToolService.exerciseList);

    this.selfTrainingToolService.loading = false;

  }

  resetState() {
    this.modelConfirmationMessage.showMesssageConfirmationModal('Warning!', 'This will reset all exercises progress. Do you want to continue?',
      "Yes", "No", () => {
        for (const exercise of this.selfTrainingToolService.exerciseList) {
          exercise.done = false;
          exercise.comments = "";
        }
        this.saveState();
      })
  }

  checkIfChanges(){
    if (this.selfTrainingToolService.exerciseList == null || this.selfTrainingToolService.exerciseList.length == 0){
      return false;
    }
    if (this.selfTrainingToolService.exerciseListBackUp == null || this.selfTrainingToolService.exerciseListBackUp.length == 0){
      return false;
    }
    for (let i = 0;i<this.selfTrainingToolService.exerciseList.length; i++){
      if (this.selfTrainingToolService.exerciseList[i].done != this.selfTrainingToolService.exerciseListBackUp[i].done ||
        this.selfTrainingToolService.exerciseList[i].comments != this.selfTrainingToolService.exerciseListBackUp[i].comments){
        return true;
      }
    }
    return false;
  }

  checkIfZeroState() {
    for (const exercise of this.selfTrainingToolService.exerciseList) {
      if (exercise.done || exercise.comments) {
        return false;
      }
    }
    return true;
  }
}
